export const defaultFormVal = {
  "subject": "",
  "content": "",
  "emails": []
}